module.exports = __webpack_public_path__ + "fonts/NespressoLucas-BoldItalic.woff2?v=5b10f9221961153d9b376cf00f5ddc00";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-BoldItalic.woff2
// module id = 648
// module chunks = 0